import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <Link
              to="/"
              className="text-2xl font-['Pacifico'] text-white mb-4 inline-block"
            >
              <img className="w-48" src="/img/white-logo-rect.png" alt="OnGroom Logo" />
            </Link>
            <p className="text-gray-300 mb-6">
              Connecting beauty professionals with clients through innovative
              technology.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-primary/20 hover:bg-primary/30 rounded-full transition-colors"
              >
                <i className="ri-instagram-line text-white"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-primary/20 hover:bg-primary/30 rounded-full transition-colors"
              >
                <i className="ri-facebook-fill text-white"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-primary/20 hover:bg-primary/30 rounded-full transition-colors"
              >
                <i className="ri-twitter-x-line text-white"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-primary/20 hover:bg-primary/30 rounded-full transition-colors"
              >
                <i className="ri-linkedin-fill text-white"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="#features"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Features
                </a>
              </li>
              <li>
                <a
                  href="#rewards"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Rewards
                </a>
              </li>
              <li>
                <a
                  href="#how-it-works"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  How It Works
                </a>
              </li>
              <li>
                <a
                  href="#faq"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  FAQ
                </a>
              </li>
              <li>
                <Link
                  to="/terms-conditions"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-2">
              <li className="flex items-start">
                <i className="ri-mail-line mr-3 mt-1 text-primary"></i>
                <span className="text-gray-300">support@ongroom.com</span>
              </li>
              <li className="flex items-start">
                <i className="ri-phone-line mr-3 mt-1 text-primary"></i>
                <span className="text-gray-300">+91 8276996645</span>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line mr-3 mt-1 text-primary"></i>
                <span className="text-gray-300">Kolkata, India</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Stay Updated</h3>
            <p className="text-gray-300 mb-4">
              Subscribe to our newsletter for the latest updates and news.
            </p>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="flex">
                <input
                  type="email"
                  placeholder="Your email address"
                  className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-l focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary text-white text-sm"
                />
                <button
                  type="submit"
                  className="bg-primary text-white px-4 !rounded-r-button whitespace-nowrap hover:bg-primary-dark transition-colors"
                >
                  Subscribe
                </button>
              </div>
            </form>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8 text-center">
          <p className="text-gray-400">
            &copy; {new Date().getFullYear()} OnGroom. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;